import { api } from '@/shared/api/client'
import { useSessionStore } from '@/shared/store/session'

/**
 * Rehidrata la sesión al arrancar la app.
 *
 * Si la cookie de refresh es válida devuelve un access token nuevo; si no,
 * el usuario queda como anónimo. Un 401 aquí es el caso normal (visitante
 * sin sesión), no un error que haya que mostrar.
 */
export async function bootstrapSession() {
  try {
    const { data } = await api.post('/auth/refresh', null, { skipAuthRefresh: true })
    useSessionStore.getState().setSession(data)
    return true
  } catch {
    useSessionStore.getState().markAnonymous()
    return false
  }
}

export async function logout() {
  try {
    await api.post('/auth/logout', null, { skipAuthRefresh: true })
  } finally {
    useSessionStore.getState().clearSession()
  }
}
